import { QueryFunctionContext } from '@tanstack/react-query';
import { getSFLItems as _getSFLItems } from 'common/save-for-later-service';
import { ATGSFLGetItemsResponse } from 'common/types/ATGSFLResponse';

export const getSFLItems = async ({
  queryKey: [, , isLocal],
}: QueryFunctionContext<[key: 'sfl', csrf: string | undefined, isLocal: boolean]>): Promise<ATGSFLGetItemsResponse> => {
  const cachedItems = sessionStorage.getItem('sfl_product_list');
  if (cachedItems) return JSON.parse(cachedItems);

  const res = await _getSFLItems(isLocal);
  sessionStorage.setItem('sfl_product_list', JSON.stringify(res));

  return res;
};
